import { createApi } from '@reduxjs/toolkit/query/react';
import { API_INVENTORY_URL } from '@/utils';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { DepartmentApi, DepartmentsFilter } from '../models';

const departmentService = createApi({
  reducerPath: 'departmentService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/departments`),
  tagTypes: ['Departments'],
  endpoints: (builder) => ({
    getDepartments: builder.query<
      PaginatedResponse<DepartmentApi>,
      { filters?: DepartmentsFilter; paginated: PaginatedRequest }
    >({
      query: ({ paginated }) => ({
        url: '',
        params: {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        },
      }),
      providesTags: ['Departments'],
    }),
    createDepartment: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Departments'],
    }),
    updateDepartment: builder.mutation({
      query: ({ id, body }) => ({
        url: `/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Departments'],
    }),
  }),
});

export default departmentService;
export const { 
  useGetDepartmentsQuery, 
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation 
} = departmentService;
